import {
    CVC,
    PERIOD,
    STTC,
    VOY,
} from '_legacy/components/toolPanels/commonSettings/OrderOrFixtureTypes';
import {
    DATASET_SPECIALISED,
    DATASET_LNG,
    DATASET_TANKERS,
    DATASET_PCG,
    DATASET_LPG_MIDSIZE,
} from './Datasets';
import { TankersGroupType } from './TankersGroupTypes';

export const typesByDataset = (
    datasetId: number,
    tankersGroupType: TankersGroupType | null | undefined
) => {
    switch (datasetId) {
        case DATASET_SPECIALISED:
            return ['VOY', 'TCT', 'PERIOD', 'COA', 'UNKNOWN', 'SALE'];
        case DATASET_TANKERS:
            // For Tankers Period groups, remove TCT and VOY
            if (tankersGroupType === TankersGroupType.Period) {
                return ['PERIOD', 'STTC', 'COA', 'UNKNOWN'];
            }

            // For Tankers Spot groups, remove TCT and Period
            if (tankersGroupType === TankersGroupType.Spot) {
                return ['VOY', 'COA', 'STTC', 'UNKNOWN'];
            }
            return ['VOY', 'TCT', 'PERIOD', 'COA', 'UNKNOWN', 'STTC'];
        case DATASET_PCG:
            return ['VOY', 'TCT', CVC, STTC, 'PERIOD', 'COA', 'UNKNOWN'];
        case DATASET_LPG_MIDSIZE:
            return ['VOY', 'TCT', 'PERIOD', 'COA', 'UNKNOWN', STTC];
        default:
            return ['VOY', 'TCT', 'PERIOD', 'COA', 'UNKNOWN'];
    }
};

export const groupSortingByType = (datasetId, tankersGroupType) => {
    switch (datasetId) {
        case DATASET_SPECIALISED:
            return ['PERIOD', 'TCT', 'VOY', 'COA', 'UNKNOWN', 'SALE'];
        case DATASET_TANKERS:
            // For Tankers Period groups, use new order: Period, STTC, COA, Unknown
            if (tankersGroupType === TankersGroupType.Period) {
                return ['PERIOD', 'STTC', 'COA', 'UNKNOWN'];
            }

            // For Tankers Spot groups, remove TCT and Period
            if (tankersGroupType === TankersGroupType.Spot) {
                return ['VOY', 'COA', 'STTC', 'UNKNOWN'];
            }
            // For Tankers Spot groups, keep existing order
            return ['VOY', 'TCT', 'PERIOD', 'COA', 'UNKNOWN', 'STTC'];
        case DATASET_PCG:
            return ['VOY', 'TCT', CVC, STTC, 'PERIOD', 'COA', 'UNKNOWN'];
        case DATASET_LPG_MIDSIZE:
            return ['VOY', 'TCT', 'PERIOD', 'COA', 'UNKNOWN', STTC];
        default:
            return ['PERIOD', 'TCT', 'VOY', 'COA', 'UNKNOWN'];
    }
};

export const getCustomDisplayNameByDataset = (datasetId) => {
    if (datasetId === DATASET_LNG) {
        return [
            { value: VOY, label: 'SPOT' },
            { value: PERIOD, label: 'MULTI' },
        ];
    }

    return [];
};
